// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__V84L7"};